import React from "react";
import { Button } from "./Button";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer-container">
      <div className='footer-wrapper'>
        <div className="footer-items">
          <h2 className="footer-contact-title">
            Location
          </h2>
          <p className="footer-contact-text">
            545 Academy Rd <br/>
            Winnipeg, Manitoba<br/>
            R3N 1J3<br/>
            (204) 487-1872
          </p>
          <br/>
          <p className="fotter-copyRight">Copyright © 2022 Sushi Academy</p>
        </div>
        <div className="footer-items">
          <h2 className="footer-hours-title">
            Open Hours
          </h2>
          <p className="footer-hours-text">
            Mon — 11:30a.m. - 9p.m.<br/>
            Tue — Closed <br/>
            Wed — 11:30a.m. - 9p.m.<br/>
            Thu — 11:30a.m. - 9p.m.<br/>
            Fri — 11:30a.m. - 9p.m.<br/>
            Sat — 11:30a.m. - 9p.m.<br/>
            Sun —  3:30p.m. - 8p.m.<br/>
          </p>
        </div>
      </div>
    </div>
  )
};

export default Footer;